import React from 'react'
import MarkerWithLabel from './MarkerWithLabel'
import helpers from '../helpers'

const MerchantMap = ({ data }) => (
  <React.Fragment>
    <MarkerWithLabel
      location={data.merchantLocation}
      icon={helpers.icons.restaurant}
      label={data.merchantName}
      labelColor={helpers.getLabelColor()}
    />

    <MarkerWithLabel
      location={data.deliveryLocation}
      icon={helpers.icons.userHome}
      label='User Address'
      labelColor={helpers.getLabelColor()}
    />
  </React.Fragment>
)

export default MerchantMap



// WEBPACK FOOTER //
// ./src/containers/mapView/components/MerchantMap.js